module.exports = __webpack_public_path__ + "media/images/icons/icons_large/27_saxafon-797f4774eb6823ce7b8ccdb69ed3eded.png";